import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { Button, DialogActions, DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';
import { handleDeleteOrgUser } from '@/component/system/handler/UserManagementHandler';
import './ConfirmDeleteOrgUserDialog.css';

export default function ConfirmDeleteOrgUserDialog({argsAll}) {
    
    const handleAgree = () => {
        if (!argsAll.isOpenDialogConfirmDelete.userId) {
            return;
        }

        if (argsAll.isOpenDialogConfirmDelete.isEnable && argsAll.isOpenDialogConfirmDelete.userId) {
            
            // Remove user in org
            handleDeleteOrgUser(argsAll, argsAll.isOpenDialogConfirmDelete.userId);
        }

        argsAll.setIsOpenDialogConfirmDelete({ isEnable: false, userId: null });
    };

    const handleDisagree = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        argsAll.setIsOpenDialogConfirmDelete({ isEnable: false, userId: null });
    };

    return (
        <Dialog
            open={argsAll.isOpenDialogConfirmDelete.isEnable}
            onClose={(event, reason) => handleDisagree(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="alert-dialog-delete-addition-user"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-delete-addition-user-content">
                    
                    {I18n.get('USER09MSG006')}
                    
                </DialogContentText>
            </DialogContent>
            <DialogActions className="confirm-delete-user-dialog-action">
                <Button
                    onClick={handleAgree}
                    autoFocus
                    className="btn-handle-delete-user btn-handle-delete-user-agree"
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    onClick={handleDisagree}
                    className="btn-handle-delete-user btn-handle-delete-user-disagree"
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
